import {useEnvironmentContext} from 'src/hooks/useEnvironmentContext';

import type {RouteLocationParam, Router} from 'src/types/router';


type UseWebAndExtRouterControl = {
  changeLocation: (
    router: Router,
    newLocation: string | RouteLocationParam,
    openInNewTab?: boolean,
    openInNewWindowOnlyForExtension?: boolean,
  ) => void;
};

export const useWebAndExtRouterControl = (): UseWebAndExtRouterControl => {
  const {isExtension} = useEnvironmentContext();
  const push = (
    router: Router,
    intendedLocation: string | RouteLocationParam,
  ) => {
    router.push(intendedLocation);
  };

  const replace = (
    router: Router,
    intendedLocation: string | RouteLocationParam,
  ) => {
    router.replace(intendedLocation);
  };

  const prepareLocation = (
    router: Router,
    newLocation: RouteLocationParam | string,
  ) => {
    const {context, ver} = router.location.query;
    const intendedLocation =
      typeof newLocation === 'string'
        ? {pathname: newLocation, query: {}}
        : newLocation;
    if (context) {
      intendedLocation.query = {...intendedLocation.query, context, ver};
    }

    return intendedLocation;
  };

  const changeLocation = (
    router: Router,
    newLocation: string | RouteLocationParam,
    openInNewTab?: boolean,
    openInNewWindowOnlyForExtension?: boolean,
  ) => {
    const intendedLocation = prepareLocation(router, newLocation);
    if (openInNewTab || (openInNewWindowOnlyForExtension && isExtension)) {
      window.open(intendedLocation.pathname, '_blank');
      return;
    }
    if (isExtension) {
      replace(router, intendedLocation);
    } else {
      push(router, intendedLocation);
    }
  };

  return {
    changeLocation,
  };
};
